'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const Markdown = require('markdown-to-jsx');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Modal_Modal = require('../../display/Modal/Modal.cjs.js');
const components_display_Modal_ModalContent = require('../../display/Modal/ModalContent.cjs.js');
require('react');
const components_navigation_Button_Button = require('../../navigation/Button/Button.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const Markdown__default = /*#__PURE__*/_interopDefault(Markdown);

const gap = "var(--zds-space-16, 15px)";
const Styles = styleEncapsulation.labelStyles("PolicyModal", {
  title: react.css`
    ${styleMixins_reset.baseReset};
  `,
  markdown: react.css`
    text-align: left;

    p {
      &:not(:last-child) {
        margin: 0 0 ${gap};
      }
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-bottom: ${gap};
      &:not(:first-of-type) {
        margin-top: ${gap};
      }
    }

    ul {
      ${styleMixins_reset.baseReset};
      margin-left: var(--zds-space-20);
      list-style: disc;
    }
  `
});
const PolicyModal = ({ onAccept, title, tldr, url, renderMarkdown = (markdown) => react.jsx(Markdown__default.default, null, markdown) }) => {
  return react.jsx(
    components_display_Modal_Modal.Modal,
    { canClose: false, onClosed: () => {
    } },
    react.jsx(
      components_display_Modal_ModalContent.ModalContent,
      { maxWidth: "70ch" },
      react.jsx(
        components_display_Modal_ModalContent.ModalContentHeader,
        null,
        react.jsx(
          "h1",
          { "data-zds": true, css: Styles.title },
          "We’ve updated the ",
          title
        )
      ),
      react.jsx(
        components_display_Modal_ModalContent.ModalContentBody,
        { scrollable: true },
        react.jsx("div", { css: Styles.markdown, "data-zds": true }, renderMarkdown(tldr))
      ),
      react.jsx(
        components_display_Modal_ModalContent.ModalContentFooter,
        null,
        !!url && react.jsx(components_navigation_Button_Button.Button, { color: "secondary", href: url, target: "_blank" }, "Review changes"),
        react.jsx(components_navigation_Button_Button.Button, { color: "primary", hasShadow: true, onClick: onAccept }, "Accept")
      )
    )
  );
};

exports.PolicyModal = PolicyModal;
//# sourceMappingURL=PolicyModal.cjs.js.map
